<template>
  <span
    class="flex items-center size-8 cursor-pointer shadow-sm border border-transparent rounded relative text-white bg-blue-600 hover:bg-blue-500  focus:border-white focus:outline-none focus:ring-2 ring-offset-white focus:ring-blue-500 active:bg-blue-700"
  >
    <stormy-icon
      name="tabler-cloud-upload"
      class="size-6 mx-auto"
      :stroke-width="2"
    />
  </span>
</template>
